import { Area } from "./styled";

export default function Card(props) {
  return <Area style={props.style}>{props.children}</Area>;
}
